import { FIRST_MODULE_ALIAS } from '@/domain/services/installation/modules/menu';

const Sensors = () => import(/* webpackChunkName: "sensors" */ '../sensors');
const Supervision = () => import(/* webpackChunkName: "supervision" */ '../Supervision');
const SupervisionIndex = () => import(/* webpackChunkName: "supervision" */ '../index');

export default {
  path: 'supervisao',
  name: 'monitoring.supervision',
  component: SupervisionIndex,
  meta: { breadcrumb: { name: 'page-name.supervision', noTitle: true, noNavigation: true } },
  redirect: {
    name: 'monitoring',
  },
  children: [
    {
      path: ':assetId',
      name: 'monitoring.supervision.asset',
      component: Supervision,
      redirect: to => ({
        name: 'monitoring.supervision.sensors',
        params: {
          ...to.params,
          sensorId: FIRST_MODULE_ALIAS,
        },
      }),
      children: [
        {
          path: 'sensor/:sensorId',
          name: 'monitoring.supervision.sensors',
          component: Sensors,
        },
      ],
    },
  ],
};
